import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  onClick,
  href,
  className = ''
}: CtaButtonProps) {
  const classes = `group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-amber hover:bg-amberHover text-navy font-bold text-lg md:text-xl rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 ${className}`;
  if (href) {
    const handleClick = () => {
      trackAddToCart();
    };
    return <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={classes} data-id="element-32">
        <span data-id="element-33">{children}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-34" />
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-35">
      <span data-id="element-36">{children}</span>
      <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-37" />
    </button>;
}